/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-17 17:15:30
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-06 11:17:35
 * @FilePath: /unifyxp-v2-store-portal/src/error/code.ts
 */
export const errCodesMap = {
  104300: 'Content Home Page UUID cannot be null',
  104301: 'Content Home Page cannot be found',
  104302: 'You have no privilege to manipulate this content home page',
  104305: 'Modules cannot be empty',
  104306: 'Module name is too long',
  104307: 'Module type cannot be empty',
  104310: 'Poster type cannot be empty',
  104311: 'Interval time cannot be zero or negative',
  104315: 'Link type cannot be empty',
  104316: 'Link library cannot be empty',
  104317: 'Link product or action cannot be empty',
  104318: 'Link collection cannot be empty',
  104319: 'Store page cannot be empty',
  104320: 'Campaign page cannot be empty',
  104321: 'System module cannot be empty',
  104325: 'Product to show cannot be empty',
  104324: 'There must be four products in a group',
  104326: 'There must be two products in a group',
  104327: 'There must be three products in a group',
  104328: 'Interval time of product carousel cannot be zero or negative',
  104329: 'Scroll type cannot be empty',
  104333: 'Poster type cannot be empty',
  104334: 'There must be two modules in a group',
  104335: 'There must be three modules in a group',
  104336: 'There must be four modules in a group',
  104337: 'Link modules cannot be empty',
  104340: 'SEO tag cannot be empty',
  104341: 'Text header cannot be empty',
  104342: 'Text header is too long',
  104343: 'Text content is too long',
  104344: 'Text color cannot be empty',
  104345: 'Text color is too long',
  104346: 'Background color cannot be empty',
  104347: 'Background color is too long',
  104350: 'Product to show cannot be empty',
  104355: 'Products cannot be empty',
  104356: 'Icon color is too long',
  104357: 'Title tag is too long',
  104358: 'Description tag is too long',
  199220: 'Image UUID cannot be null',
  199221: 'The image field cannot be empty',
  100000: 'Hot tags titles cannot be empty',
  100001: 'Hot tags cannot be empty',
  100002: 'Caption cannot be empty',
  100003: 'Service cannot be empty',
  999999: 'Text cannot be empty',
  999998: 'The image field cannot be empty',
  999997: 'Tab Bar name cannot be empty',
  999996: 'Time setting cannot be empty',
  999995: 'Tab title, link and icon cannot be empty ',
  999994: 'Product Name  cannot be empty',
  999993: 'Title cannot be empty ',
  999992: 'Menu cannot be empty ',
  999991: 'Link cannot be empty ',
  999990: 'Please Add at least 1 field',
  999989: 'Please Select a content page',
  999988: 'Please input summary',
  999987: 'Please input subtitle',
  999986: 'Time setting cannot be empty',
  999985: 'Time is not valid',

  999983: 'File size exceeds the limit',
  999982: 'File type is not allowed to upload',
  999984: 'Please input successful message',
  999981: ' A Popup window Promotion already exists with the same name.',
  999980: 'Video cannot be empty',
  999979:
    'Add at least one Terms & Conditions with marketing consent attribute.',
  999978: 'This field cannot be empty',
  999977: 'No time setting',
  999976: 'Customer Infomation Fields cannot be empty.',

  999975: 'There must be one product in a group',
  999974: 'There must be four products in a group',
  999973: 'There must be five products in a group',
  999972: 'There must be six products in a group',
  999971: 'There must be one modules in a group',
  999970: 'There must be four modules in a group',
  999969: 'There must be five modules in a group',
  999968: 'There must be six modules in a group',
  999967: 'Module(s) cannot be empty',
  999966: 'Please Input Tab Name',
  999965: 'Image/Poster Name cannot be empty',
  999964: 'Image/Video cannot be empty',
  999963: 'Image Link cannot be empty',

  999961: 'There must be four content pages in the group',
  999960: 'There must be five content pages in the group',
  999959: 'There must be six content pages in the group',
  999957: 'There must be three content pages in the group',
  999956: 'There must be two content pages in the group',
  999955: 'There must be one content page in the group',

  999954: 'Please add at least four products in the module',
  999953: 'Please add at least five products in the group',
  999952: 'Please add at least six products in the group',
  999951: 'Please add at least three products in the group',
  999950: 'Please add at least two products in the group',
  999949: 'Please add at least one product in the group',

  999948: 'Please note this content page is invalid at this time',

  999947: 'Please add four products in the module',
  999946: 'Please add five products in the group',
  999945: 'Please add six products in the group',
  999944: 'Please add three products in the group',
  999943: 'Please add two products in the group',
  999942: 'Please add one product in the group',

  999941: 'There must be at least four content pages in the group',
  999940: 'There must be at least five content pages in the group',
  999939: 'There must be at least six content pages in the group',
  999938: 'There must be at least three content pages in the group',
  999937: 'There must be at least two content pages in the group',
  999936: 'There must be at least one content page in the group',
};
